<template>
  <span v-if="json.like" @click="click('like')" style="cursor: pointer">👍</span>
  <span v-if="json.dislike" @click="click('dislike')" style="cursor: pointer">👎</span>

</template>

<script>
export default {
  props: ["json"],
  inject:["widgetMethods"],
  methods: {
    click(what) {
      this.widgetMethods.sendMessage("\\vote" + JSON.stringify({action: what, who: this.json.who}));
    }
  }
}
</script>
